import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByStatus',
})
export class OrderByStatusPipe implements PipeTransform {
  transform(cajas: any[]): any[] {
    if (!Array.isArray(cajas)) return [];

    return cajas.slice().sort((a, b) => {
      const aFecha = a?.ultimaActualizacion?.seconds || 0;
      const bFecha = b?.ultimaActualizacion?.seconds || 0;

      const isAActive = this.isCajaActiva(aFecha);
      const isBActive = this.isCajaActiva(bFecha);

      // Inactivas primero
      if (isAActive === isBActive) return 0;
      return isAActive ? 1 : -1;
    });
  }

  private isCajaActiva(seconds: number): boolean {
    const ms = seconds * 1000;
    const diferencia = Date.now() - ms;
    return diferencia < 5 * 60 * 1000; // menos de 5 min
  }
}
